import React from 'react';

const Page = React.lazy(() => import('./TuitionReportPage'));

const TuitionReportConfig = {
	settings: { layout: { config: {} } },
	routes: [
		{
			path: '/billing/reports/tuition',
			element: (
				<React.Suspense fallback={<>...</>}>
					<Page />
				</React.Suspense>
			),
		},
	],
	auth: ['school_admin', 'super_school_admin', 'sub_admin'],
};

export default TuitionReportConfig;
